export default __webpack_public_path__ + "static/media/bat-logo.26c9b1d3.svg";